import { render, staticRenderFns } from "./app-root.vue?vue&type=template&id=79ee2616"
import script from "./app-root.vue?vue&type=script&lang=js"
export * from "./app-root.vue?vue&type=script&lang=js"
import style0 from "./app-root.vue?vue&type=style&index=0&id=79ee2616&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports